import { Bell, Check, Download } from '@phosphor-icons/react';
import { Button, Loader, VText } from '@vake/ui-kit';
import { FC } from 'react';
import { SendToMattermost } from '../send-to-mattermost';

export type DownloadProps = {
    downloadFullDataset: boolean;
    setDownloadFullDataset: (value: boolean) => void;
    isLoadingDownload: boolean;
    isSuccessDownload: boolean;
    isErrorDownload: boolean;
    errorMessageDownload: string;
};
export const DownloadView: FC<DownloadProps> = ({
    downloadFullDataset,
    setDownloadFullDataset,
    isLoadingDownload,
    isSuccessDownload,
    isErrorDownload,
    errorMessageDownload,
}) => {
    return (
        <div>
            {!downloadFullDataset && !isSuccessDownload && (
                <Button
                    onClick={() => setDownloadFullDataset(true)}
                    text="Download dataset in CSV format"
                    iconBefore={<Download size={16} />}
                    variant="neutral"
                    size="xsmall"
                />
            )}
            {isLoadingDownload && (
                <div className="flex justify-center">
                    <Loader size={16} />
                </div>
            )}
            {isSuccessDownload && (
                <div className="flex items-center gap-2">
                    <Check size={16} color="green" />
                    <VText variant="B2">Download complete</VText>
                </div>
            )}
            {isErrorDownload && (
                <div>
                    <VText variant="B2">Download failed: {errorMessageDownload}</VText>
                    <SendToMattermost
                        textOnButton={'Send error report'}
                        iconOnButton={<Bell size={16} />}
                        textToSend={`Error downloading dataset: ${errorMessageDownload} in actor mode report.`}
                        successMessage={'Error report sent!'}
                    />
                </div>
            )}
        </div>
    );
};
